.TV {
    position: absolute;
    inset: 0;
    transform: scale(0.8);
}
.TV.ScaledDown {
    transform: unset;
    width: 372.5px;
    height: 266px;
}
.TVimg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.TVVideo {
    position: absolute;
    top: 290px;
    left: 625px;
    width: 1000px;
    height: 900px;
    background-color: black;
}
.ScaledDown .TVVideo {
    top: 20px;
    left: 20px;
    width: 254px;
    height: 230px;
}
.VHS {
    position: absolute;
    top: 1100px;
    right: 100px;
    width: 400px;
    cursor: grab;
}
.ScaledDown .VHS {
    top: 230px;
    width: 100px;
    right: -100px;
}
.VHSDropTarget {
    position: absolute;
    right: 600px;
    bottom: 670px;
    width: 280px;
    height: 500px;
}

.TVVideoInternal {
    position: absolute;
    width: 1000px;
    height: 900px;
}

.ScaledDown .TVVideoInternal {
    top: 0;
    left: 0;
    width: 254px;
    height: 230px;
}

.TVVideoInternal.TVVideoLawyer {
    position: absolute;
    top: 120px;
    left: 250px;
    width: 490px;
    height: 846px;
}

.TVVideoInternal.TVVideoGramps {
    position: absolute;
    top: 180px;
    left: 210px;
    width: 531px;
    height: 677px;
}

.ScaledDown .TVVideoInternal.TVVideoLawyer {
    top: 30px;
    left: 59px;
    width: 127px;
    height: 216px;
}

.ScaledDown .TVVideoInternal.TVVideoGramps {
    top: 40px;
    left: 57px;
    width: 137px;
    height: 173px;
}

.TVVideoScanlines.Playing {
    animation-name: scanlineAnimation;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes scanlineAnimation {
    0% {
        transform: translate(0px, 0px);
    }
    100% {
        transform: translate(0px, -26px);
    }
}
